import React, { useState, useEffect } from "react";
import axios from "axios";
import Loader from "../../Components/Loader";

function ContactUs() {
  const [conversation, setConversation] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [issending, setissending] = useState(false);
  const [username, setUsername] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminEmail = process.env.REACT_APP_ADMIN_EMAIL; // Assuming admin email is stored in environment variables

  const fetchUsername = async () => {
    try {
      const token = localStorage.getItem("spanUserToken") || "";
      const response = await axios.get(
        `${apiUrl}userdatafetch.php?token=${encodeURIComponent(token)}`
      );
      setUsername(response.data.data.username);
    } catch (error) {
      console.error("Failed to fetch username:", error);
    }
  };

  useEffect(() => {
    fetchUsername();
  }, []);

  const fetchMessages = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}receivemessage.php?Username=${username}`
      );
      if (response.data.status === "success") {
        const validMessages = response.data.data.filter(
          (message) => !isNaN(new Date(message.TimeStamp).getTime())
        );

        validMessages.sort((a, b) => {
          return new Date(a.TimeStamp) - new Date(b.TimeStamp);
        });

        setConversation(validMessages);
      }
    } catch (error) {
      console.error("Failed to fetch messages:", error);
    }
  };

  useEffect(() => {
    if (username) {
      fetchMessages();
      const intervalId = setInterval(fetchMessages, 15000); // Fetch messages every 15 seconds

      return () => clearInterval(intervalId); // Clear interval on component unmount
    }
  }, [username]);

  const handleMessageChange = (event) => {
    setNewMessage(event.target.value);
  };

  const handleSendMessage = async () => {
    if (newMessage.trim() !== "") {
      setissending(true);
      try {
        const timeStamp = new Date().toISOString();
        const response = await axios.get(
          `${apiUrl}sendmessage.php?TimeStamp=${encodeURIComponent(
            timeStamp
          )}&Message=${encodeURIComponent(
            newMessage
          )}&Sender=user&Username=${encodeURIComponent(username)}`
        );
        if (response.data.status === "success") {
          setConversation((prevConversation) => [
            ...prevConversation,
            {
              TimeStamp: timeStamp,
              Message: newMessage,
              Sender: username,
              Username: username,
            },
          ]);
          setNewMessage("");
          await sendEmailToAdmin(newMessage);
        }
      } catch (error) {
        console.error("Failed to send message:", error);
      } finally {
        setissending(false);
      }
    }
  };

  const sendEmailToAdmin = async (message) => {
    try {
      const subject = "New Message from User";
      const body = `
        <h1>You have a new message from a user</h1>
        <p><strong>Username:</strong> ${username}</p>
        <p><strong>Message:</strong> ${message}</p>
        <p>Please <a href="https://spanip.com/admin/user/${username}/contactus">Click Here</a> to see message </p>
      `;
      await axios.post(process.env.REACT_APP_MAIL_API, {
        receiverMail: adminEmail,
        subject,
        body,
      });
    } catch (error) {
      console.error("Failed to send email to admin:", error);
    }
  };

  const oneMessage = (chat, index) => {
    const time = new Date(chat.TimeStamp).toLocaleTimeString();
    return (
      <div className={chat.Sender} key={index}>
        <h6>{chat.Sender}</h6>
        <p>{chat.Message}</p>
        <span>{time}</span>
      </div>
    );
  };

  return (
    <>
      {issending ? <Loader /> : null}
      <div className="UserContactUs">
        <div id="conversation">
          {conversation.map((chat, index) => oneMessage(chat, index))}
        </div>
        <div id="sendbox">
          <input
            type="text"
            placeholder="Send Message.."
            value={newMessage}
            onChange={handleMessageChange}
          />
          <i
            className="fa-solid fa-paper-plane"
            onClick={handleSendMessage}
          ></i>
        </div>
      </div>
    </>
  );
}

export default ContactUs;
